import React from 'react';
import { Section } from './ui/Section';
import { Countdown } from './ui/Countdown';
import { motion } from 'framer-motion';
export const UrgencyCountdown: React.FC = () => {
  return <Section className="bg-brand-card/50 border-y border-brand-card-border" data-id="element-299">
      <div className="max-w-3xl mx-auto text-center" data-id="element-300">
        <h2 className="text-2xl md:text-4xl font-black mb-8 flex items-center justify-center gap-3 text-[#EF4444]" data-id="element-301">
          <span data-id="element-302">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>

        <div className="mb-10" data-id="element-303">
          <Countdown data-id="element-304" />
        </div>

        <div className="bg-red-500/10 border border-red-500/30 text-red-400 font-bold py-3 px-6 rounded-lg inline-block mb-8" data-id="element-305">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </div>

        <div className="max-w-md mx-auto" data-id="element-306">
          <div className="flex justify-between text-sm font-bold mb-2" data-id="element-307">
            <span className="text-white flex items-center gap-2" data-id="element-308">
              🔴 Cupos al precio de lanzamiento:
            </span>
            <span className="text-brand-green" data-id="element-309">68% ya tomados</span>
          </div>
          <div className="h-4 bg-brand-dark rounded-full overflow-hidden border border-brand-card-border" data-id="element-310">
            <motion.div className="h-full bg-brand-green" initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} data-id="element-311" />
          </div>
        </div>
      </div>
    </Section>;
};